import { onMounted, ref, readonly } from '@nuxtjs/composition-api';
import getProductEngravingData from '~/modules/catalog/product/queries/getProductEngravingData.gql';
import { useApi } from '~/composables';

import { EngravingOptionInput } from '~/modules/GraphQL/types';

import { useProductEngravingInterface, GetProductEngraving, ProductEngraving } from './useProductEngraving';

export function useProductEngraving(sku: string): useProductEngravingInterface {
  const { query } = useApi();

  const engraving = ref<ProductEngraving | null>(null);
  const isEngravingLoading = ref<boolean>(true);
  const shouldIncludeEngraving = ref(false);
  const isEngravingModalOpened = ref(false);
  const engravingOptions = ref<EngravingOptionInput>({
    handedness: '',
    font: '',
    place: '',
    text: '',
  });

  const setEngravingModalOpenState = (opened?: boolean) => {
    isEngravingModalOpened.value = !!opened;
    document.getElementsByTagName('body')[0].style.overflow = opened ? 'hidden' : 'scroll';
  };

  const setActiveEngraving = (e: EngravingOptionInput) => {
    shouldIncludeEngraving.value = true;
    setEngravingModalOpenState(false);
    engravingOptions.value = e;
  };

  const fetchProductEngravingData = async () => {
    try {
      const { data: optionData } = await query<GetProductEngraving>(getProductEngravingData, { sku });
      if (optionData?.products?.items) {
        engraving.value = optionData?.products?.items[0];
        isEngravingLoading.value = false;
      }
    } catch (error) {
      console.log('ERROR:', error);
    }
  };

  onMounted(async () => {
    await fetchProductEngravingData();
  });

  return {
    engraving,
    setActiveEngraving,
    setEngravingModalOpenState,
    engravingOptions: readonly(engravingOptions),
    isEngravingLoading: readonly(isEngravingLoading),
    shouldIncludeEngraving: readonly(shouldIncludeEngraving),
    isEngravingModalOpened: readonly(isEngravingModalOpened),
  };
}

export * from './useProductEngraving';
export default useProductEngraving;
